import React, { Component } from 'react'
import { employementTypeList, postedJobsCount, postJob } from '../../action/jobs';
import PostAJob from '../../old_Components/PostAJob/PostAJob'
import constant from '../../constant'
import Swal from 'sweetalert2';
import AsideRightMenu from '../../old_Components/Dashboard/AsideRightMenu';
import Shimmer from '../../old_Components/Common/Shimmer';
import { Link } from 'react-router-dom';
export default class JobPosting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            LISTNING_TYPE: {
                name: 'LISTNING_TYPE', value: 1, options: [
                    { value: '1', name: 'Regular' },
                    { value: '2', name: 'Featured' },
                    { value: '3', name: 'Premium' }
                ], error: '', isRequired: false
            },
            showLoader: false,
            regularCount: undefined,
            totaljobsbalance: undefined

        }
    }
    componentDidMount() {
        document.title = constant.title.PostRegularJob
        postedJobsCount().then(res => {
            if (res.status) {
                this.setState({ regularCount: res.result.regular.total, totaljobsbalance: res.result.totaljobsbalance })
            }
            else {
                alert(res.error)
            }
        }).catch(error => {
            alert(error)
        })
    }
    onSubmit = (model) => {
        this.setState({ showLoader: true })
        postJob(model).then(res => {
            this.setState({ showLoader: false })
            if (res.status) {
                this.props.history.push('/dashboard')
                this.setState({ showLoader: false })
                Swal.fire({
                    icon: 'success',
                    text: res.result.message,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                text: error,
                timer: 5000,
                showCancelButton: false,
                showConfirmButton: false
            })
        })
    }
    render() {
        const { LISTNING_TYPE, regularCount, totaljobsbalance } = this.state
        return (
            <React.Fragment>
                {totaljobsbalance && regularCount < totaljobsbalance.REGULAR_POSTING && <PostAJob
                    onSubmit={this.onSubmit}
                    LISTNING_TYPE={LISTNING_TYPE.value}
                    showLoader={this.state.showLoader}
                />}
                {totaljobsbalance && regularCount >= totaljobsbalance.REGULAR_POSTING && <section className="pricing-area padding-top-100px padding-bottom-80px">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>
                            <div className="col-md-9 padding-top-20px">
                                <div class="alert alert-danger" role="alert">
                                    <span> You do not have an active Subscription for Job Posting on JobzShala. <a href={constant.component.JobPackage.url} > Click Here </a> to get JobzShala Subscription.</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>}
                {totaljobsbalance === undefined && <section className="pricing-area padding-top-100px padding-bottom-80px">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>
                            <div className="col-md-9 padding-top-20px">
                                <Shimmer />
                            </div>
                        </div>
                    </div>
                </section>}
            </React.Fragment>
        )
    }
}
